/*
Reducers:
Tell to  how the state of our application should  whenever a given action occurs
*/
/*initial Value, action thet produce call to this reducer*/


import moment from "moment";



export const defaultIntermediate = {
    rsc: "atos",
    isLive: true,
    current: null,
    selected: null,
    finalPosition: null,
    extendedColsVisibles: null
}


const InitialTimeZone = () => {
    const sessionTimeZone = localStorage.getItem("displayTimeZone");
    const localtimeSession = sessionTimeZone === "host" ? false : true  //null value not defined by default is true (user)

    if (localtimeSession) {
        return moment.tz.guess()
    } else {
        return process.env.REACT_APP_TIME_ZONE
    }

}

const initialStateAppGlobal = {
    localtime: true, //Indica si por defecto se muestra la hora local
    timezone: InitialTimeZone(),// moment.tz.guess(), //process.env.REACT_APP_TIME_ZONE, hora por defecto 
    locale: "en",
    rsc: "",
    competition: 'NONE',
    discipline: "NONE",
    event: "",
    phase: "",
    date: "",
    rsctime: "",
    components: {
        phaseSelector: {
            elementSelected: "",
            eventUnitExpanded: false
        }
    },
    intermediateSelector:
        [{
            rsc: "ATOS",
            isLive: true,
            current: null,
            selected: null,
            finalPosition: null,
            extendedColsVisibles: null
        }]


}

export const appGlobalReducer = (state = initialStateAppGlobal, action) => {

    const { type } = action;
    switch (type) {
        case 'CHANGE_TIMEZONE':
            const tz = action.payload.localtime ? moment.tz.guess() : process.env.REACT_APP_TIME_ZONE
            const localtime = action.payload.localtime
            //Store in LoacalStorage comunicate with external apps
            localStorage.setItem("displayTimeZone", localtime ? "user" : "host");
            return Object.assign({}, state, {
                localtime: localtime,
                timezone: tz
            });

        case 'CHANGE_COMPETITION':
            return Object.assign({}, state, {
                competition: action.payload.competition
            });

        case 'CHANGE_RSC':
            return Object.assign({}, state, {
                rsc: action.payload.rsc
            });


        case 'CHANGE_DAY':
            return Object.assign({}, state, {
                date: action.payload.day
            });

        case 'CHANGE_EVENT':
            return Object.assign({}, state, {
                event: action.payload.event
            });

        case 'CHANGE_PHASE':
            return Object.assign({}, state, {
                phase: action.payload.phase
            });

        case 'CHANGE_LOCALE':
            return Object.assign({}, state, {
                locale: action.payload.locale
            });

        case 'COMPONENT_PHASESELECTOR_CHANGE_PHASE':
            return Object.assign({}, state, {
                components: {
                    phaseSelector: {
                        elementSelected: action.payload.phase
                    }
                }
            });
        case 'COMPONENT_PHASESELECTOR_CHANGE_EXPANDED':
            return Object.assign({}, state, {
                components: {
                    phaseSelector: {
                        eventUnitExpanded: action.payload.expanded
                    }
                }
            });

        case 'COMPONENT_INTERMEDIATESELECTOR_CHANGE':
            const intermediateSelector = state?.intermediateSelector
            if (action.payload?.intermediateSelector?.rsc) {
                let obj = Array.isArray(intermediateSelector) && intermediateSelector.find(element => element?.rsc === action.payload.intermediateSelector?.rsc);
                //let objIndex = Array.isArray(intermediateSelector) && intermediateSelector.findIndex(element => element?.rsc === action.payload.intermediateSelector?.rsc);
                let others = Array.isArray(intermediateSelector) && intermediateSelector.filter(element => element?.rsc !== action.payload.intermediateSelector?.rsc);
                let val = Object.assign({}, state, { intermediateSelector: [...others, { ...obj, ...action.payload.intermediateSelector }] });
                return val
            } else {
                return { ...state }
            }


        case 'CHANGE_TIME_RSC':
            return Object.assign({}, state, {
                rsctime: action.payload.time
            });

        default:
            return state;

    }

}